import { g, Tool } from '@hcie/core';
import { eyeDropperColor, magicWandSelection } from '@hcie/tools';
import { getActiveLayer, renderLayers } from '../layers';

/**
 * Secondary Tools Handler
 * Handles utility tools like Eyedropper, Magic Wand, Zoom, and Pan.
 */
export class SecondaryToolsHandler {
    /**
     * Handles mouse down events for secondary tools.
     * @param e Mouse event
     * @returns true if the event was handled
     */
    static handleMouseDown(e: MouseEvent): boolean {
        const id = g.current_tool.id;

        if (id === Tool.Eye_Dropper.id) {
            this.runEyedropper();
            return true;
        }

        if (id === Tool.Wand.id) {
            this.runMagicWand(e);
            return true;
        }

        if (id === Tool.Zoom_In.id) {
            g.zoom *= (g.zoomFactor || 1.2);
            renderLayers();
            return true;
        }

        if (id === Tool.Zoom_Out.id) {
            g.zoom /= (g.zoomFactor || 1.2);
            renderLayers();
            return true;
        }

        return false;
    }

    /**
     * Picks a color from the composited canvas.
     */
    private static runEyedropper() {
        const canvas = document.getElementById("drawingCanvas") as HTMLCanvasElement;
        const ctx = canvas?.getContext("2d");
        if (!ctx) return;

        // Use integer coordinates for pixel picking
        const x = Math.floor(g.pX);
        const y = Math.floor(g.pY);
        
        const color = eyeDropperColor(x, y, ctx);
        if (color) {
            g.pen_color = color;
            // Dispatch event to update UI indicators
            window.dispatchEvent(new CustomEvent('colorChanged', { 
                detail: { color: g.pen_color, source: 'eyedropper' } 
            }));
            
            // If there's a global update function for UI
            if (typeof (window as any).updateOptionsBar === 'function') {
                (window as any).updateOptionsBar();
            }
        }
    }

    /**
     * Executes magic wand selection on the active layer.
     */
    private static runMagicWand(e: MouseEvent) {
        const activeLayer = getActiveLayer();
        if (!activeLayer || !activeLayer.ctx) return;

        const tolerance = g.fill_tolerance || 30;
        const mode = e.shiftKey ? "add" : (e.altKey ? "subtract" : "replace");

        magicWandSelection(
            Math.floor(g.pX), 
            Math.floor(g.pY), 
            activeLayer.ctx as CanvasRenderingContext2D, 
            tolerance, 
            mode as any
        );
        renderLayers();
    }
}
